// extracted by mini-css-extract-plugin
module.exports = {"groupLabel":"dropdownSearch_groupLabel__2hBl_","groupBadge":"dropdownSearch_groupBadge__3UK95"};